export const FAVORITES_LIMIT_FOR_UNAUTHENTICATED_USER = 5;

export const MOTIVATION_COOKIE_EXPIRATION = 24 * 3600;
export const MOTIVATION_COOKIE_NAME = 'newbuilding-favorite_motivation';
